import {
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { LlmProxyKeysClient, llmProxyKeysApiRef } from './api/LlmProxyKeysClient';

export const llmProxyKeysApiFactory = createApiFactory({
  api: llmProxyKeysApiRef,
  deps: {
    discoveryApi: discoveryApiRef,
    fetchApi: fetchApiRef,
    identityApi: identityApiRef,
  },
  factory: ({ discoveryApi, fetchApi, identityApi }) =>
    new LlmProxyKeysClient(discoveryApi, fetchApi, identityApi),
});
